// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cart: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 23"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M3.437.75c.321 0 .6.222.67.535l.19.84H23.28c.873 0 1.569.87 1.324 1.747l-2.32 8.252a1.376 1.376 0 01-1.324 1.001H6.798l.627 2.75h13.888a.69.69 0 01.687.688.69.69 0 01-.687.687H6.875a.689.689 0 01-.67-.537L2.889 2.125H.688a.687.687 0 110-1.375h2.75zM4.611 3.5l1.839 8.25h14.51l2.32-8.25H4.61zM5.5 20.344a2.408 2.408 0 012.406-2.407 2.408 2.408 0 012.406 2.407 2.408 2.408 0 01-2.406 2.406A2.408 2.408 0 015.5 20.344zm2.406 1.031c.572 0 1.031-.46 1.031-1.031 0-.572-.46-1.032-1.03-1.032-.572 0-1.032.46-1.032 1.032 0 .571.46 1.031 1.031 1.031zM22 20.344a2.408 2.408 0 01-2.406 2.406 2.408 2.408 0 01-2.407-2.406 2.408 2.408 0 012.407-2.407A2.408 2.408 0 0122 20.345zm-2.406-1.032c-.572 0-1.032.46-1.032 1.032 0 .571.46 1.031 1.032 1.031.571 0 1.031-.46 1.031-1.031 0-.572-.46-1.032-1.031-1.032z" />
        </svg>
    );
};

export default React.memo(Cart);
